import React from "react";
import Popup from "devextreme-react/popup";
import Button from "devextreme-react/button";
import axios from "axios";
import { connect } from "react-redux";
import data from "../../assets/apiRoutes.json";
import { useHistory } from "react-router-dom";

const DeleteReceiptDialog = (props) => {
  const history = useHistory();
  const accessToken = props.oidc.user.access_token;
  const changeReceiptItemsObject = props.ReceiptReducer.changeReceipt.changeItems;

  const { handleClose, open } = props;
  const deleteReceiptItemsObject = {
    items: changeReceiptItemsObject,
    rowid: props.rowid,
    dbName: props.ReceiptReducer.wmTransactionDatabase || "",
  };

  const deleteExistingRecord = () => {
    axios.post(
      `${window._env_.REACT_APP_APIS}/${data.Receipt.DeleteTransactions}`,
      deleteReceiptItemsObject,
      {
        headers: {
          "Content-Type": "application/json",
          access_token: accessToken,
        },
      }
    );
    handleClose();
    history.push("/wm/transaction");
  };

  return (
    <Popup
      visible={open}
      onHiding={handleClose}
      dragEnabled={false}
      closeOnOutsideClick={true}
      title="Deleting Transaction"
      showCloseButton={true}
      width={530}
      height={266}
    >
      <div style={{ padding: "20px" }}className="title">
        <h5 style={{ fontWeight: "500", marginTop: "10px" }}>
          Are you sure you want to delete this open{" "}
          <span style={{ color: window._env_.Color2 }}>
            Transaction No. {props.transactionNumber}?
          </span>
        </h5>
      </div>
      <div style={{ textAlign: "left", padding: "10px 20px" }}>
        <Button
          onClick={deleteExistingRecord}
          className="accordianButton" text="Confirm" type="default"
        />
        <Button
          onClick={handleClose}
          className="accordianButton" text="Cancel"
        />
      </div>
    </Popup>
  );
};

function mapStateToProps(state) {
  return {
    ReceiptReducer: state.ReceiptReducer,
    oidc: state.oidc,
  };
}

export default connect(mapStateToProps)(DeleteReceiptDialog);
